import { apiClient, handleResponse, handleError } from '@/helpers/api'

// EXPORTS
export const sftpService = {
  get,
  set,
  del
}

// API CALLS
async function get() {
  return apiClient
    .get('/SFTPConfiguration')
    .then(handleResponse)
    .catch(handleError)
}

async function set(payload) {
  return apiClient
    .post('/SFTPConfiguration', payload)
    .then(handleResponse)
    .catch(handleError)
}

async function del() {
  return apiClient
    .delete('/SFTPConfiguration')
    .then(handleResponse)
    .catch(handleError)
}
